// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
// TODO. Duplicate. Almost the same as StopOrderEdit.
import { Intervals } from '@shared/utils/Instruments/Intervals';
import { OrderType } from '@shared/utils/Trading/OrderType';
import { Resources } from '@shared/localizations/Resources';
import { DynProperty } from '../../../DynProperty';
import { NumericUtils } from '@shared/utils/NumericUtils';
import { OrderEditUpdateData } from '@shared/utils/Trading/OrderEditUpdateData';
import { SLTPEdit } from '../SLTPEdit';
import { OrderEditBaseUtils } from '@shared/utils/Trading/OrderEditBaseUtils';
import { OrderEditBase } from './OrderEditBase';
export class LimitOrderEdit extends OrderEditBase {
    constructor(data, orderType = OrderType.Limit) {
        super(data);
        this._orderType = OrderType.Manual;
        this._orderType = orderType;
        this.limitPrice = null;
        this.sltp = new SLTPEdit(data.dataCache, data.sltpMode);
        this.sltpBasePriceGetter = this.sltpBasePriceGetter.bind(this);
        this.needSetDefaultPrice = false;
    }
    getParameterNameArray() {
        return [
            OrderEditBaseUtils.LIMIT_PRICE_PARAM,
            OrderEditBaseUtils.LIMIT_PRICE_PARAM_CHANGE_FROM_LAST_PRICE,
            OrderEditBaseUtils.POSITION_SIZING_PARAM,
            OrderEditBaseUtils.SLTP_PARAM,
            OrderEditBaseUtils.OFFMARKET_ENABLED,
            OrderEditBaseUtils.EST_AVAILABLE_CASH
        ];
    }
    // TODO. Refactor. Same as OrderTypeBase.Id function.
    getOrderTypeId() {
        return this._orderType;
    }
    // TODO. Refactor. Use error/warning dicts for sltp.
    // public valid ()
    // {
    //     return OrderEditBase.prototype.valid.call(this) &&
    //         this.sltp.valid()
    // }
    // #region Update Parameter Handlers
    update_limitPrice(updateData) {
        var _a;
        let parameterChanged = false;
        const dp = updateData.dp;
        if (dp && this.limitPrice !== dp.value && !(isNaN(this.limitPrice) && isNaN(dp.value))) {
            this.limitPrice = dp.value;
            parameterChanged = true || parameterChanged;
        }
        let newInstrument = null;
        let newQuote = null;
        let sideChanged = false;
        const newTradingDataDict = updateData.newTradingDataDict;
        if (newTradingDataDict) {
            newInstrument = newTradingDataDict.instrument;
            newQuote = newTradingDataDict.quote;
            sideChanged = 'side' in newTradingDataDict;
        }
        if (newInstrument) {
            this.limitPrice = null;
            this.needSetDefaultPrice = true;
            parameterChanged = true || parameterChanged;
        }
        if (this.needSetDefaultPrice && newQuote) {
            this.needSetDefaultPrice = false;
            this.limitPrice = newQuote.BidSpread_SP_Ins((_a = this.instrument) === null || _a === void 0 ? void 0 : _a.DataCache.GetSpreadPlan(this.account), this.instrument);
            parameterChanged = true || parameterChanged;
        }
        if (newQuote || sideChanged || parameterChanged) {
            parameterChanged = this.tryUpdateWarning_limitPrice(this.limitPrice, this.quote) || parameterChanged;
            parameterChanged = this.tryUpdateWarningForChangeFromLastPrice(this.limitPrice) || parameterChanged;
        }
        return parameterChanged;
    }
    tryUpdateWarning_limitPrice(limitPrice, quote) {
        var _a;
        if (!quote) {
            return false;
        }
        const sp = (_a = this.instrument) === null || _a === void 0 ? void 0 : _a.DataCache.GetSpreadPlan(this.account);
        const ask = quote.AskSpread_SP_Ins(sp, this.instrument);
        const bid = quote.BidSpread_SP_Ins(sp, this.instrument);
        const buy = this.buy();
        const newWarning = buy && limitPrice >= ask
            ? 'general.trading.limitBuyLessAsk'
            : !buy && limitPrice <= bid
                ? 'general.trading.limitSellMoreBid'
                : null;
        return this.warningsManager.setParameterWarning(OrderEditBaseUtils.LIMIT_PRICE_PARAM, newWarning);
    }
    tryUpdateWarningForChangeFromLastPrice(limitPrice) {
        const ins = this.instrument;
        if (!ins)
            return;
        if (!ins.UseWarningForChangeFromLastPrice()) {
            return false;
        }
        let lastPrice = ins.Level1.GetLastPrice(this.account);
        let noLastPrice = false;
        let newWarning = null;
        if (!lastPrice) {
            // 4.2.1 about Reference price instead of Last price
            noLastPrice = true;
            lastPrice = ins.Level1 ? ins.Level1.getReferencePrice : null;
        }
        const lastChange = ins.GetChangeByPrice(lastPrice);
        if (this.buy()) {
            if (lastPrice !== null && limitPrice <= lastPrice - (lastChange * lastPrice) / 100) {
                newWarning = noLastPrice
                    ? 'general.trading.limitBuyLessAllowableFromBase'
                    : 'general.trading.limitBuyLessAllowableFromLast';
            }
        }
        else {
            if (lastPrice !== null && limitPrice >= lastPrice + (lastChange * lastPrice) / 100) {
                newWarning = noLastPrice
                    ? 'general.trading.limitSellMoreAllowableFromBase'
                    : 'general.trading.limitSellMoreAllowableFromLast';
            }
        }
        if (newWarning) {
            // пока думаю что кешировать Resources.getResource(newWarning) нецелесообразно ведь помимо проверки не поменялся ли ключ необходимо будет следить не поменялся ли язьік приложения, не факт что от кеширования по итогу можно будет вьіиграть
            const lastPriceStr = ins.formatPrice(lastPrice);
            newWarning = Resources.getResource(newWarning).replace('{1}', lastPriceStr);
        }
        return this.warningsManager.setParameterWarning(OrderEditBaseUtils.LIMIT_PRICE_PARAM_CHANGE_FROM_LAST_PRICE, newWarning);
    }
    update_limitPriceChangeFromLast() { }
    toDynProperty_limitPriceChangeFromLast() {
        return new DynProperty();
    }
    toRawValue_limitPriceChangeFromLast() { }
    // #endregion Update Parameter Handlers
    // #region Parameters' DynProperty Generators
    toDynProperty_limitPrice() {
        const dp = new DynProperty(OrderEditBaseUtils.LIMIT_PRICE_PARAM);
        dp.type = DynProperty.DOUBLE;
        const ins = this.instrument;
        const intrvls = Intervals.GetIntervalsFromInstrument(ins, NumericUtils.MAXVALUE);
        if (ins) {
            dp.minimalValue = intrvls && intrvls.length > 0 ? intrvls[0].LeftValue : ins.PointSize;
            dp.maximalValue = 999999999;
            dp.decimalPlaces = ins.Precision;
            dp.increment = ins.PointSize;
        }
        if (intrvls) {
            dp.Intervals = intrvls;
        }
        dp.value = this.limitPrice;
        if (dp.value === null || isNaN(dp.value)) {
            dp.value = dp.minimalValue;
        }
        dp.localizationKey = 'panel.newOrderEntry.limitPricePanel';
        return dp;
    }
    // #endregion Parameters' DynProperty Generators
    // #region Raw Values
    toRawValue_limitPrice() {
        return this.limitPrice;
    }
    // #endregion Raw Values
    validateParameters() {
        const updatedParamNameDict = {};
        if (this.sltp.validate(this.sltpBasePriceGetter, this.sltpBasePriceGetter, this.getTradingData())) {
            updatedParamNameDict[OrderEditBaseUtils.SLTP_PARAM] = true;
        }
        updatedParamNameDict[OrderEditBaseUtils.POSITION_SIZING_PARAM] = true;
        return updatedParamNameDict;
    }
    // #region SLTP Price Comparer
    sltpBasePriceGetter() {
        return this.limitPrice;
    }
    // #endregion SLTP Price Comparer
    createConfirmationTextParams() {
        const textParams = super.createConfirmationTextParams();
        textParams.OrderTypeKey = 'Limit';
        textParams.PriceArray = [this.limitPrice];
        textParams.OrderType = OrderType.Limit;
        return textParams;
    }
    // Returns SlTpHolder instance.
    // TODO. UGLY. Refactor. details are at the top OrderEditBase
    getRawSLTP() {
        return this.sltp.getRawValue(this.getTradingData());
    }
    // TODO. UGLY. Refactor. details are at the top OrderEditBase
    setLimitPrice(price) {
        const dp = this.createDynPropertyFromParameter(OrderEditBaseUtils.LIMIT_PRICE_PARAM);
        dp.value = price;
        this.updateParameters(new OrderEditUpdateData({ limitPrice: dp }));
    }
    // TODO. Refactor. Details are in OrderEditBase.
    setBasePrice(price) {
        const dp = this.createDynPropertyFromParameter(OrderEditBaseUtils.LIMIT_PRICE_PARAM);
        dp.value = price;
        this.updateParameters(new OrderEditUpdateData({ limitPrice: dp }));
    }
    // TODO. Refactor. Details are in OrderEditBase.
    getBasePrice() {
        return this.limitPrice;
    }
}
